import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import DashboardIcon from '../../../assets/images/sidebar-icons/Dashboard.svg';

import { routeKeys } from '../../../constants/Breadcrumb';
import { useAppSelector } from '../../../redux/hook';

import './Breadcrumb.scss';

const Breadcrumb = () => {
  const location = useLocation();
  const readerReportImei = useAppSelector((state) => state.readerReports.readerReport?.imei);

  // The "Report" crumb has no list page of its own - it's reached either from
  // Scan Sessions or from a reader's own detail page, so route it back to
  // whichever one it actually came from instead of a dead `/report` URL.
  const source = (location.state as { source?: string } | undefined)?.source;
  const reportParentUrl = source === 'scanSessions' ? '/scansessions' : readerReportImei ? `/readers/${readerReportImei}` : undefined;

  const pathSnippets = location.pathname
    .split('/')
    .filter((segment: string) => segment && segment !== 'visit-log')
    .map((segment: string) => {
      if (segment === 'reader') return 'readers';
      if (segment === 'device') return 'devices';

      return segment;
    });

  if (pathSnippets.length === 0) {
    return null;
  }

  const getBreadcrumbLabel = (path: string): string => {
    const breadcrumbKeys = routeKeys as Record<string, string>;

    if (breadcrumbKeys[path]) {
      return breadcrumbKeys[path];
    }

    // Fallback for routes that are not defined in routeKeys
    return path
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <nav className='breadcrumb' aria-label='breadcrumb'>
      <Link to='/' className='breadcrumb__home'>
        <img src={DashboardIcon} alt='' aria-hidden='true' className='breadcrumb__home-icon' />

        <span className='breadcrumb__home-label'>Home</span>
      </Link>

      {pathSnippets.map((path, index) => {
        const isLast = index === pathSnippets.length - 1;

        const url = path === 'report' && reportParentUrl ? reportParentUrl : `/${pathSnippets.slice(0, index + 1).join('/')}`;

        const label = getBreadcrumbLabel(path);

        return (
          <React.Fragment key={`${path}-${index}`}>
            <span className='breadcrumb__separator' aria-hidden='true'>
              /
            </span>

            {isLast ? (
              <span className='breadcrumb__current' aria-current='page'>
                {label}
              </span>
            ) : (
              <Link to={url} className='breadcrumb__link'>
                {label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
